import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import accountApi from '../../services/accountApi';

function OrganizationSettingsPage() {
  const { activeTenantId } = useAuth();
  const [partner, setPartner] = useState(null);
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!activeTenantId) return;
      setLoading(true);
      setError(null);
      try {
        const data = await accountApi.getPartner(activeTenantId);
        if (!cancelled) {
          setPartner(data);
          setName(data.name || '');
          setSlug(data.slug || '');
        }
      } catch (err) {
        if (!cancelled) setError(err.message || 'Failed to load partner settings');
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [activeTenantId]);

  const handleSave = async (event) => {
    event.preventDefault();
    if (!activeTenantId) return;
    setSaving(true);
    setError(null);
    setSuccess(null);
    try {
      const updated = await accountApi.updatePartner(activeTenantId, { name, slug });
      setPartner(updated);
      setSuccess('Partner settings updated.');
    } catch (err) {
      setError(err.message || 'Failed to update partner');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <h1 className="product-page-title">Partner Settings</h1>
      <p className="product-page-subtitle">Partner name, slug, and status.</p>

      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}
      {loading && (
        <div className="loading-state">
          <Spinner animation="border" size="sm" className="me-2" />
          Loading…
        </div>
      )}

      {!loading && partner && (
        <div className="product-card">
          <Form onSubmit={handleSave}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control value={name} onChange={(e) => setName(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Slug</Form.Label>
              <Form.Control value={slug} onChange={(e) => setSlug(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Type</Form.Label>
              <Form.Control
                value={partner.partner_type || partner.tenant_type || ''}
                readOnly
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Control value={partner.status || ''} readOnly />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Service tier</Form.Label>
              <Form.Control value={partner.service_tier || '—'} readOnly />
            </Form.Group>
            <Button type="submit" disabled={saving}>
              {saving ? 'Saving…' : 'Save changes'}
            </Button>
          </Form>
        </div>
      )}
    </div>
  );
}

export default OrganizationSettingsPage;
